<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="isPreview ? '预览' : pkId > 0 ? '编辑' : '新建'"
        class="dialog"
        width="1200px"
        top="5vh"
        append-to-body
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          class="form"
          :model="model"
          :disabled="isPreview"
          :rules="ruleValidate"
          label-width="120px">
        <div class="title">订单信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="sapDeliveryType">
              <span slot="label">
                <span style="color: #000;">发货单类型:</span>
              </span>
              <el-select v-model="model.sapDeliveryType" placeholder="请选择发货单类型">
                <el-option label="工控发货单" :value="0"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="pkId" :span="12">
            <el-form-item v-if="salesOrderId">
              <span slot="label">
                <span style="color: #000;">发货单号</span>
              </span>
              <el-input v-model="model.billNo" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="SAP订单号">
              <span slot="label">
                <span style="color: #000;">SAP订单号:</span>
              </span>
              <span>{{model.salesOrderNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <span slot="label">
                <span style="color: #000;">客户名称:</span>
              </span>
              <span>{{model.customerName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同编号">
              <span slot="label">
                <span style="color: #000;">合同编号</span>
              </span>
              <span>{{model.customerContractNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销单交期">
              <span slot="label">
                <span style="color: #000;">销单交期</span>
              </span>
              <span>{{model.salesDeliveryDate}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货日期" prop="deliveryDate">
              <span slot="label">
                <span style="color: #000;">发货日期</span>
              </span>
              <el-date-picker
                  v-model="model.deliveryDate"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择发货日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货地址" prop="deliveryAddress" :rules="[{ required: deliveryType === 'back' ? false : true, message: '请输入收货地址', trigger: 'blur' }]">
              <span slot="label">
                <span style="color: #000;">收货地址</span>
              </span>
              <el-input v-if="deliveryType === 'back'" v-model="model.deliveryAddress"/>
              <el-input
                  v-else
                  v-model="model.deliveryAddress"
                  placeholder="请输入收货地址"
                  :disabled="!model.customerId">
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="!model.customerId"
                    @click="$refs.addressSelect.open(model.customerId)"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货人">
              <span slot="label">
                <span style="color: #000;">收货人</span>
              </span>
              <el-input v-model="model.contact" placeholder="请输入收货人姓名"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <span slot="label">
                <span style="color: #000;">联系电话</span>
              </span>
              <el-input v-model="model.phone" placeholder="请输入联系电话"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流方式">
              <span slot="label">
                <span style="color: #000;">物流方式</span>
              </span>
              <el-select v-model="model.logisticsMethod" placeholder="请选择物流方式" @change="selectMethod">
                <el-option label="跨越速运" :value="'跨越速运'"/>
                <el-option label="顺丰速运" :value="'顺丰速运'"/>
                <el-option label="供应商直发" :value="'供应商直发'"/>
                <el-option label="公司车送货" :value="'公司车送货'"/>
                <el-option label="客户自提" :value="'客户自提'"/>
                <el-option label="顺丰到付" :value="'顺丰到付'"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销单类型">
              <span slot="label">
                <span style="color: #000;">销单类型</span>
              </span>
              <span>{{model.salesOrderCategoryName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="打印类型">
              <span slot="label">
                <span style="color: #000;">打印类型</span>
              </span>
              <el-select v-model="model.printType" placeholder="请选择打印类型">
                <el-option label="标准样式发货单" :value="0"/>
                <el-option label="无公司抬头发货单" :value="1"/>
                <el-option label="商务上传发货单" :value="2"/>
                <el-option label="客户物料送货单" :value="3"/>
                <el-option label="恒强送货单" :value="4"/>
                <el-option label="终端客户送货单" :value="5"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="deliveryType === 'back'" :span="12">
            <!-- 退回时需要添加这个字段 -->
            <el-form-item label="是否质检">
              <span slot="label">
                <span style="color: #000;">是否质检</span>
              </span>
              <el-radio-group v-model="model.isQualityCheck">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <span slot="label">
                <span style="color: #000;">备注</span>
              </span>
              <el-input v-model="model.deliveryNote1" maxlength="130" show-word-limit placeholder="请输入备注"/>
            </el-form-item>
          </el-col>
          <!-- 如果deliveryType===back（待办退回），则需要添加一个质量分析 -->
          <el-col v-if="deliveryType === 'back'" :span="24">
            <el-form-item label="质量分析">
              <span slot="label">
                <span style="color: #000;">质量分析</span>
              </span>
              <el-input v-model="model.qualityAnalise" show-word-limit placeholder="请输入质量分析"/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="title">待发物料</div>
        <template v-if="deliveryType !== 'back'">
          <el-select
              v-model="selectedMaterial"
              style="width: 40%; margin-bottom: 10px; margin-right: 10px"
              placeholder="请选择物料"
              @focus="getMaterialListNoAdd">
            <el-option
                v-for="item in materialListNoAdd"
                :key="item.materialNo"
                :label="item.materialNo + '，' + item.materialName"
                :value="item"/>
          </el-select>
          <el-button type="primary" :disabled="!selectedMaterial" @click="addMaterial">添加</el-button>
          <el-button type="primary" @click="checkAllHandle">全选</el-button>
        </template>
        <el-table :data="model.detailAppVOS" border>
          <el-table-column prop="salesOrderRowIndex" align="center" width="100" label="销售订单行项"/>
          <el-table-column prop="rowIndex" align="center" width="100" label="交货单行项"/>
          <el-table-column
              v-if="model.property === 'ZRCH'"
              prop="SWAP_T"
              align="center"
              width="50"
              label="换入"/>
          <el-table-column prop="materialNo" align="center" width="120" label="物料编号"/>
          <el-table-column
              v-if="deliveryType === 'back'"
              prop="mappingMaterialNo"
              align="center"
              width="120"
              label="旧物料号"/>
          <el-table-column prop="materialName" align="left" show-overflow-tooltip label="物料描述"/>
          <el-table-column prop="specification" align="left" show-overflow-tooltip label="规格型号"/>
          <el-table-column prop="note" align="left" width="120" label="发货备注(对外)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column prop="innerNote" align="left" width="120" label="发货备注(内部)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.innerNote" type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column prop="salesOrderQuantity" align="center" width="80" label="销单数量"/>
          <el-table-column prop="quantity" align="center" width="80" label="数量"/>
          <template v-if="deliveryType !== 'back'">
            <el-table-column prop="deliveryQuantity" align="center" width="80" label="已发数量"/>
            <el-table-column prop="salesOrderRemainingQuantity" align="center" width="80" label="未发数量"/>
            <el-table-column align="center" width="100" label="发货数量">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.shipQuantity"
                    class="shipQuantityInput"
                    placeholder="请输入"
                    @input="quantityChange(scope.row, $event, scope.$index)"/>
              </template>
            </el-table-column>
          </template>
          <template>
            <el-table-column align="center" width="120" label="库位">
              <template slot-scope="scope">
                <el-select v-model="scope.row.location">
                  <el-option
                      v-for="item in constants.locationNo.$options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </template>
            </el-table-column>
          </template>
          <el-table-column
              v-if="deliveryType === 'back'"
              prop="locationNo"
              align="center"
              width="120"
              label="小仓位"/>
          <el-table-column fixed="right" label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button v-if="deliveryType !== 'back'" type="danger" :diabled="isPreview" @click="deleteHandle(scope.$index)"> 删除</el-button>
              <el-button v-if="deliveryType === 'back'" type="primary" :diabled="isPreview" @click="handleSplit(scope.$index)"> 拆分</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="title">客户发货单</div>
        <upload-file
            ref="upload"
            :auth-index="authIndex"
            @upload-success="uploadSuccess"/>
        <el-table class="tableBox" :data="model.customerFileList" border>
          <el-table-column label="名称" prop="fileName" width="200"/>
          <el-table-column label="备注" prop="note"/>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <down-load-file :file-key="scope.row.filePath"/>
              <el-button type="danger" :disabled="isPreview" @click="deleteOneFile(scope.$index,scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <address-select ref="addressSelect" @select="addressSelect"/>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
            v-if="!isPreview"
            :loading="saveLoading"
            type="primary"
            @click="sure(0, 'saveLoading')">保存</el-button>
        
        <!--        <el-button-->
        <!--            v-if="!isPreview && model.status"-->
        <!--            :loading="submitLoading"-->
        <!--            type="primary"-->
        <!--            @click="sure(1, 'submitLoading')">提交</el-button>-->
      </span>
    </el-dialog>

    <!-- 拆分数量弹窗 -->
    <split-quantity-dialog
        :visible.sync="splitDialogVisible"
        :item="splitItem"
        @confirm="handleSplitConfirm"/>
  </div>
</template>

<script>
  import constants from "@/util/constants";
  import UploadFile from "@/components/UploadFile";
  import DownLoadFile from "@/components/DownLoadFile";
  import AddressSelect from "@/views/information/Customer/CustomerAddressSelect";
  import SplitQuantityDialog from "./components/SplitQuantityDialog";

  export default {
    components: {UploadFile,DownLoadFile,AddressSelect,SplitQuantityDialog},
    props: {
      salesOrderId: {
        type: Number,
      },
      // back:代办退回
      deliveryType: {
        type: String,
        default: "forward",
      },
    },
    data() {
      return {
        isPreview: false,
        constants,
        contentLoading: false,
        saveLoading: false,
        submitLoading: false,
        dialogVisible: false,
        splitDialogVisible: false,
        splitItem: {},
        splitIndex: -1,
        pkId: 0,
        isZdq: false,
        authIndex: this.$route.meta.authIndex,
        pickerOptions: {
          disabledDate(time) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const threeDaysLater = new Date();
            threeDaysLater.setDate(today.getDate() + 3);
            threeDaysLater.setHours(23, 59, 59, 999);
            return time.getTime() > threeDaysLater.getTime();
          },
        },
        model: {
          billNo: "", // 发货单号
          sapDeliveryType: 0, // 发货单类型
          salesOrderNo: "", // SAP订单号
          customerPurchaseOrderNo: "", // 客户合同号
          customerId: "", // 客户名称
          customerName: "", // 客户名称
          customerNo: "", // 客户名称
          deliveryDate: "", // 要求交货日期
          salesDeliveryDate: "",//销售订单交期
          deliveryAddress: "", // 收货地址
          logisticsMethod: "跨越速运",
          pcbLabel: "中文",
          isReleased: 10,
          printType: 0,
          contact: "", // 收货人
          phone: "", // 联系电话
          noteOne: "", // 备注1
          qualityAnalise: "", // 质量分析
          isQualityCheck: false, // 是否质检
          noteThree: "", // 备注3
          noteFour: "", // 备注4
          details: [], // 待发物料table
          deliveryBusinessTime: "",
          deliveryBusinessNote: "",
          deliveryNote1: "",
          deliveryNote2: "",
          salesOrderCategoryName: "",
          property: "",
          status: 0,
          customerFileList: [],
        },
        materialListNoAdd: [], // 未添加的物料
        selectedMaterial: "", // 选中的物料
        program: [], // 程序
        ruleValidate: {
          deliveryDate: {
            required: true,
            message: "请选择要求发货日期",
            trigger: "change",
          },
          sapDeliveryType: {
            required: true,
            message: "请选择发货单类型",
            trigger: "change",
          },
          pcbLabel: {
            required: true,
            message: "请选择PCB标签语言",
          },
          deliveryBusinessTime: {
            required: true,
            message: "商务需求到货日期不可为空",
          },
        },
      };
    },
    methods: {
      mounted() {
        console.log(this.$route.meta);
      },
      open(billNo, isZdq, address) {
        this.model.billNo = billNo;
        this.isZdq = isZdq;
        if (address) {
          this.model.deliveryAddress = address;
        }
        if (billNo) {
          this.dialogVisible = true;
          // 编辑发货通知单
          this.contentLoading = true;
          this.$http
            .get("basic", `sapDeliveryBills/preview/${billNo}`)
            .then((res) => {
              if (res.success) {
                this.model = Object.assign(this.model, res.data);
                res.data.detailAppVOS.forEach((item) => {
                  item.deliveryQuantity = item.salesOrderCompletedQuantity;
                  item.shipQuantity = item.quantity;
                  item.materialProgram = item.softList ? item.softList.split(",") : "";
                });
                this.model.detailAppVOS = res.data.detailAppVOS;
                this.contentLoading = false;
                this.pkId=this.model.pkId;
                if (this.deliveryType === "back") {
                  this.model.deliveryAddress = "浙江省杭州市余杭区闲林工业区闲兴路35号四号楼";
                }
              }
            })
            .catch(() => {
              this.contentLoading = false;
            });
        } else {
          // 创建发货通知单
          this.getSalesOrderInfoBySalesOrderId();
        }
        if (isZdq === "preview") {
          this.isPreview = true;
        }
      },
      // 查询销售订单详细信息
      getSalesOrderInfoBySalesOrderId() {
        this.contentLoading = true;
        this.$http.post("basic", `sapSalesOrders/sdDetail/${this.salesOrderId}`).then((resp) => {
          if (resp.success) {
            this.model.salesOrderNo = resp.data.billNo;
            this.model.contact = resp.data.contact;
            this.model.phone = resp.data.mobile;
            this.model.customerContractNo = resp.data.customerContractNo;
            this.model.customerName = resp.data.customerName;
            this.model.customerNo = resp.data.customerNo;
            this.model.customerId = resp.data.customerId;
            this.model.deliveryDate = resp.data.deliveryDate;
            this.model.salesDeliveryDate = resp.data.salesDeliveryDate;
            this.model.property = resp.data.property;
            this.model.salesOrderCategoryName = resp.data.salesOrderCategoryName;


            if (resp.data.materialVOS.length) {//销售订单
              console.log(resp.data.materialVOS);
              resp.data.materialVOS.forEach((item) => {
                item.shipQuantity = item.salesOrderRemainingQuantity;
                item.salesOrderQuantity = item.quantity;
                item.location = item.warehouseNo;
                item.salesOrderRowIndex = item.rowIndex;
              });
              this.model.detailAppVOS = resp.data.materialVOS;
              this.dialogVisible = true;
            } else {
              this.dialogVisible = true;
            }
            this.contentLoading = false;
          }
        });
      },
      // 根据客户id查询地址、联系人、电话
      getCustomerInfo(customerNo) {
        this.$http.get("basic", `customerDeliveryAddress/chooseDefault/${customerNo}`).then((resp) => {
          if (resp) {
            this.model.contact = resp.contact;
            this.model.phone = resp.telephone;
            this.model.deliveryAddress = resp.addressName + "/" + resp.addressDetail;
          }
        });
      },
      // 查询未添加的物料
      getMaterialListNoAdd() {
        let newArr = [];
        if (this.model.detailAppVOS.length) {
          this.model.detailAppVOS.forEach((item) => {
            const obj = {
              salesOrderRowIndex: item.rowIndex,
              materialNo: item.materialNo,
            };
            newArr.push(obj);
          });
        }
        const params = {
          salesOrderNo: this.model.salesOrderNo, // SAP订单号
          detailAppVOS: newArr,
        };
        this.$http.post("basic", "sapDeliveryBills/addShipmentDetail", params).then((resp) => {
          if (resp.success) {
            this.materialListNoAdd = resp.data;
          }
        });
      },
      // 选择详细地址
      addressSelect(row) {
        console.log(row);
        this.model.deliveryAddress = row.addressName;
        this.model.contact = row.contact;
        this.model.phone = row.telephone;
      },
      // 添加物料
      addMaterial() {
        const obj = {
          salesOrderRowIndex: this.selectedMaterial.salesOrderRowIndex,
          materialNo: this.selectedMaterial.materialNo,
          materialName: this.selectedMaterial.materialName,
          sapIndexType: this.selectedMaterial.sapIndexType,
          salesOrderQuantity: this.selectedMaterial.salesOrderQuantity,
          quantity: this.selectedMaterial.salesOrderQuantity,
          deliveryQuantity: this.selectedMaterial.salesOrderCompletedQuantity,
          softList: this.selectedMaterial.softList,
          salesOrderRemainingQuantity: this.selectedMaterial.salesOrderRemainingQuantity,
          shipQuantity: 0,
          unit: this.selectedMaterial.unit,
          location: this.selectedMaterial.location,
        };
        this.model.detailAppVOS.push(obj);
        this.selectedMaterial = "";
      },
      // 删除物料
      deleteHandle(index) {
        this.model.detailAppVOS.splice(index, 1);
        console.log(this.model.detailAppVOS[index]);
        console.log(this.materialListNoAdd);
      },

      // 处理拆分
      handleSplit(index) {
        const item = this.model.detailAppVOS[index];
        this.splitItem = { ...item };
        this.splitIndex = index;
        this.splitDialogVisible = true;
      },

      // 处理拆分确认
      handleSplitConfirm(quantities) {
        console.log(quantities);
        const originalItem = this.model.detailAppVOS[this.splitIndex];
        
        // 删除原明细
        this.model.detailAppVOS.splice(this.splitIndex, 1);

        // 添加拆分后的明细
        quantities.forEach((quantity, index) => {
          const newItem = { ...originalItem };
          // newItem.salesOrderQuantity = quantity; // 销单数量
          newItem.quantity = quantity;
          // 为了区分不同的拆分项，可以添加一个后缀
          if (index>0) {
            newItem.rowIndex = "000000";
          }
          this.model.detailAppVOS.splice(this.splitIndex + index, 0, newItem);
        });
        
        this.splitIndex = -1;
        this.$message.success("拆分成功");
      },

      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };

          this.model.customerFileList.push(params);
          this.$message.success("文件上传成功");
        }
      },
      // 填写发货数量
      quantityChange(row, value, index) {
        console.log(row, value, index);
        if (value > row.salesOrderRemainingQuantity) {
          this.$message.error("发货数量超出订单剩余数量");
          this.model.detailAppVOS[index].shipQuantity = row.quantity;
          return;
        }
        this.model.detailAppVOS[index].shipQuantity = value;
      },


      // 全选后，将未发数量全部带到发货数量里
      checkAllHandle() {
        if (this.model.detailAppVOS.length) {
          this.model.detailAppVOS.forEach((item) => {
            item.shipQuantity = item.salesOrderRemainingQuantity;
          });
        }
      },
      // 保存(0)、提交(1)
      sure(type, btnLoading) {
        // console.log(this.model.detailAppVOS);
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.model.detailAppVOS.length) {
              this.$message.error("物料不能为空");
            } else if (this.model.printType === 2 && this.model.customerFileList.length === 0) {
              this.$message.error("客户发货单不能为空");
            } else {
              this[btnLoading] = true;
              let finalMaterialList = [];
              if (this.deliveryType !== "back") {
                this.model.detailAppVOS.forEach((item) => {
                  // 发货数量为0，不参与发货单创建
                  if (item.shipQuantity) {
                    item.quantity = item.shipQuantity;
                    finalMaterialList.push(item);
                  }
                });
                this.model.detailAppVOS = finalMaterialList;
              }
              if (this.pkId) {
                this.model.pkId = this.pkId;
              }
              console.log(this.model);
              if (this.deliveryType === "back") {
                // 如果是待办退回需要处理的逻辑
                this.$http
                  .post("basic", "sapDeliveryBills/uptSapDeliveryBillByTH", this.model)
                  .then(() => {
                    this.$emit("success");
                    this[btnLoading] = false;
                    this.dialogVisible = false;
                  })
                  .catch(() => {
                    this[btnLoading] = false;
                  });
              } else {
                if (this.model.status === 0) {
                  this.$http
                    .post("basic", `sapDeliveryBills/saveShipment/${type}`, this.model)
                    .then(() => {
                      this.$emit("success");
                      this[btnLoading] = false;
                      this.dialogVisible = false;
                    })
                    .catch(() => {
                      this[btnLoading] = false;
                    });
                } else {//修改SAP发货单
                  this.$http
                    .post("basic", "sapDeliveryBills/uptSapDeliveryBill", this.model)
                    .then(() => {
                      this.$emit("success");
                      this[btnLoading] = false;
                      this.dialogVisible = false;
                    })
                    .catch(() => {
                      this[btnLoading] = false;
                    });
                }
              }
            }
          }
        });
      },
      postDelivery(type, btnLoading) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.saveLoading = true;
            if (!this.model.detailAppVOS.length) {
              this.$message.error("物料不能为空");
            } else if (this.model.printType === 2 && this.model.customerFileList.length === 0) {
              this.$message.error("客户发货单不能为空");
            } else {
              this[btnLoading] = true;
              let finalMaterialList = [];
              this.model.detailAppVOS.forEach((item) => {
                // 发货数量为0，不参与发货单创建
                if (item.shipQuantity) {
                  item.quantity = item.shipQuantity;
                  finalMaterialList.push(item);
                }
              });
              this.model.detailAppVOS = finalMaterialList;
              if (this.pkId) {
                this.model.pkId = this.pkId;
              }// 如果是待办退回需要处理的逻辑
              this.model.isPostDelivery = true;
              this.$http
                .post("basic", "sapDeliveryBills/uptSapDeliveryBillByTH", this.model)
                .then(() => {
                  this.$emit("success");
                  this[btnLoading] = false;
                  this.dialogVisible = false;
                  this.$http.get("basic", `sapDeliveryBills/postDelivery/${this.model.pkId}`)
                    .then((resp) => {
                      if (resp.success) {
                        this.saveLoading = false;
                        this.$message.success("过账成功");
                        this.loadData();
                      }
                    });
                })
                .catch(() => {
                  this[btnLoading] = false;
                });
            }
          }
        });
      },

      //选择物流方式
      selectMethod() {
        if (this.model.logisticsMethod === "供应商直发") {
          this.model.detailAppVOS.forEach((item) => {
            item.location = "6901";
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #000;
}
</style>
<style lang="scss" scoped>
.el-table {
  color: #000;
}

::v-deep .el-input__inner {
  color: #000 !important;
}

::v-deep .el-input__inner::placeholder {
  color: #666;
}
</style>